import { render, staticRenderFns } from "./MasterStudio.vue?vue&type=template&id=be76f694&scoped=true"
import script from "./MasterStudio.vue?vue&type=script&lang=js"
export * from "./MasterStudio.vue?vue&type=script&lang=js"
import style0 from "./MasterStudio.vue?vue&type=style&index=0&id=be76f694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be76f694",
  null
  
)

export default component.exports